import React, { useEffect, useRef, useState } from 'react';
import { Play, X, Volume2, VolumeX } from 'lucide-react';
import { TRAILER_SRC, TRAILER_POSTER } from './pas/LandingTrailer';
import { trackTrailer } from '../utils/analytics';

const SHOW_PATHS = ['/', '/pas', '/pas/'];

export const IntroSplash = () => {
  const [show, setShow] = useState(() => SHOW_PATHS.includes(window.location.pathname));
  const [playing, setPlaying] = useState(false);
  const [leaving, setLeaving] = useState(false);
  const [muted, setMuted] = useState(false);
  const ref = useRef(null);

  const close = () => { setLeaving(true); setTimeout(() => setShow(false), 600); };
  useEffect(() => {
    if (!show) return undefined;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = ''; };
  }, [show]);

  const start = () => {
    const v = ref.current;
    v.muted = false;
    v.play().then(() => { setPlaying(true); setMuted(false); }).catch(() => { v.muted = true; v.play(); setPlaying(true); setMuted(true); });
    trackTrailer('play', 'splash-trailer-player');
  };
  const ended = () => { trackTrailer('complete', 'splash-trailer-player'); close(); };
  if (!show) return null;

  return (
    <div className={`fixed inset-0 z-[9999] bg-black flex items-center justify-center transition-opacity duration-500 print:hidden ${leaving ? 'opacity-0' : 'opacity-100'}`} data-testid="intro-splash">
      <video ref={ref} playsInline preload="auto" poster={TRAILER_POSTER} onEnded={ended}
        className={`absolute inset-0 w-full h-full ${playing ? 'object-contain' : 'object-cover'}`} data-testid="intro-video">
        <source src={TRAILER_SRC} type="video/mp4" />
      </video>
      {!playing && <div className="absolute inset-0 bg-black/45" aria-hidden="true" />}
      {!playing && (
        <div className="relative flex flex-col items-center gap-5 px-6 text-center [@media(max-height:500px)]:gap-3">
          <p className="text-[#d4af37] text-sm sm:text-base tracking-[0.5em] uppercase font-semibold" style={{ fontFamily: 'IBM Plex Mono, monospace', textShadow: '0 2px 10px rgba(0,0,0,0.9)' }}>BETHCOIN</p>
          <h1 className="text-white text-3xl sm:text-5xl [@media(max-height:500px)]:text-3xl font-bold drop-shadow-lg">Wake up. Choose BETHCOIN.</h1>
          <p className="text-slate-200 text-sm sm:text-base tracking-wide drop-shadow" data-testid="intro-stablecoin-line">BETH USD Stablecoin · 1 BETH = $1.00 · backed dollar for dollar</p>
          <button onClick={start} data-testid="intro-play-btn"
            className="mt-2 inline-flex items-center gap-3 rounded-full bg-[#d4af37] px-8 py-4 text-black font-semibold transition-transform duration-200 hover:scale-105">
            <Play className="w-5 h-5 fill-black" /> Play trailer
          </button>
        </div>
      )}
      {playing && (
        <button onClick={() => { ref.current.muted = !ref.current.muted; setMuted(ref.current.muted); }} data-testid="intro-mute-btn"
          aria-label={muted ? 'Unmute' : 'Mute'}
          className="absolute top-5 left-5 inline-flex items-center gap-2 rounded-full border border-white/30 bg-black/40 px-4 py-2 text-sm text-white backdrop-blur-md hover:bg-black/60">
          {muted ? <VolumeX className="w-4 h-4" /> : <Volume2 className="w-4 h-4" />} {muted ? 'Sound off' : 'Sound on'}
        </button>
      )}
      <button onClick={close} data-testid="intro-skip-btn"
        className="absolute top-5 right-5 inline-flex items-center gap-2 rounded-full border border-white/30 bg-black/40 px-4 py-2 text-sm text-white backdrop-blur-md hover:bg-black/60">
        Skip <X className="w-4 h-4" />
      </button>
    </div>
  );
};
